<template>
  <div id="adjustments" v-if="item.TotalAV">
    <div class="row">
      <h3 class="h4">Adjusted Assessed Values</h3>
      <div class="table-responsive">
        <table class="table table-sm table-striped table-hover table-bordered">
          <thead>
            <tr>
              <th scope="col">Description</th>
              <th scope="col" class="text-end">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Adjusted Land Value</td>
              <td class="text-end">
                {{ item.GrossLandValue | currency }}
              </td>
            </tr>
            <tr>
              <td>Adjusted Improvements Value</td>
              <td class="text-end">
                {{ item.GrossImprovementValue | currency }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-8">
        <div class="table-responsive">
          <table class="table table-sm table-borderless">
            <tbody>
              <tr>
                <th scope="row">Homestead:</th>
                <td class="text-end">
                  {{ item.Homestead | currency }}
                </td>
              </tr>
              <tr>
                <th scope="row">Residential:</th>
                <td class="text-end">
                  {{ item.Residential | currency }}
                </td>
              </tr>
              <tr>
                <th scope="row">Non-Residential:</th>
                <td class="text-end">
                  {{ item.NonResidential | currency }}
                </td>
              </tr>
              <tr>
                <th scope="row">Long-Term Care:</th>
                <td class="text-end">
                  {{ item.LongTermCare | currency }}
                </td>
              </tr>
              <tr>
                <th scope="row">AgriculturalNonRes:</th>
                <td class="text-end">
                  {{ item.AgriculturalNonRes | currency }}
                </td>
              </tr>
              <tr>
                <th scope="row">Apartment:</th>
                <td class="text-end">
                  {{ item.Apartment | currency }}
                </td>
              </tr>
              <tr>
                <th scope="row">MobileLand:</th>
                <td class="text-end">
                  {{ item.MobileLand | currency }}
                </td>
              </tr>
              <tr>
                <th scope="row">TotalAV:</th>
                <td class="text-end">
                  {{ item.TotalAV | currency }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row">
      <h3 class="h4">Adjusted Exemptions / Deductions</h3>
      <div class="table-responsive">
        <table class="table table-sm table-striped table-hover table-bordered">
          <thead>
            <tr>
              <th scope="col">Description</th>
              <th scope="col" class="text-end">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!item.AdjustmentExemptionDeductions.length">
              <td colspan="2" class="text-center text-muted p-3">
                No data
              </td>
            </tr>
            <tr
              v-for="(aed, index) in item.AdjustmentExemptionDeductions"
              v-bind:key="index"
            >
              <td>{{ aed.Name }}</td>
              <td class="text-end">{{ aed.Amount | currency }}</td>
            </tr>
          </tbody>
          <tfoot
            class="fw-bold"
            v-if="item.AdjustmentExemptionDeductions.length"
          >
            <td>Count: {{ item.AdjustmentExemptionDeductions.length }}</td>
            <td class="text-end">{{ aedTotal | currency }}</td>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    aedTotal: function() {
      return this.item.AdjustmentExemptionDeductions.reduce(function(
        prev,
        item
      ) {
        return prev + item.Amount;
      },
      0);
    },
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>
